import './ProductCategoryInformation.scss';

import { Divider, DividerColor, Skeleton } from '@eliberty/design-system-react';

import { TextHTML } from '~atoms';
import { SlopesOverview } from '~molecules';
import { Maybe, ProductCategoryAdditionalInfo } from '~types/appsync.types';

interface Props {
  title?: string;
  additionalInfo?: Maybe<ProductCategoryAdditionalInfo>;
  isLoading?: boolean;
}

const ProductCategoryInformationDesktop = ({ title, additionalInfo, isLoading = false }: Props) => {
  if (isLoading) {
    return (
      <div className='ProductCategoryInformation'>
        <Skeleton data-testid='Skeleton' height='36px' width={'40%'} />
        <Skeleton data-testid='Skeleton' height='340px' width={'100%'} radius={'8px'} />
        <Skeleton data-testid='Skeleton' height='32px' width={'50%'} />
        <Skeleton data-testid='Skeleton' height='22px' width={'80%'} />
        <Skeleton data-testid='Skeleton' height='22px' width={'70%'} />
      </div>
    );
  }

  return (
    <div className='ProductCategoryInformation'>
      <h1 className='ProductCategoryInformation_title'>{title}</h1>
      <div className='ProductCategoryInformation_images'>
        <img src={additionalInfo?.image} alt='Domaine skiable' />
      </div>
      {additionalInfo && (
        <div className='ProductCategoryInformation_content'>
          <SlopesOverview
            tagline={additionalInfo.tagline}
            numTotalSlopes={additionalInfo.numTotalSlopes}
            numSkiLift={additionalInfo.numSkiLift}
            numKmSlope={additionalInfo.numKmSlope}
            numGreenSlopes={additionalInfo.numGreenSlopes}
            numBlueSlopes={additionalInfo.numBlueSlopes}
            numRedSlopes={additionalInfo.numRedSlopes}
            numBlackSlopes={additionalInfo.numBlackSlopes}
          />
          {additionalInfo.description && <Divider color={DividerColor.MediumGrey} />}
          {additionalInfo.description && <TextHTML text={additionalInfo.description} />}
        </div>
      )}
    </div>
  );
};

export default ProductCategoryInformationDesktop;
